import { render, staticRenderFns } from "./ChallengeResults.vue?vue&type=template&id=726e6934&scoped=true&"
import script from "./ChallengeResults.vue?vue&type=script&lang=ts&"
export * from "./ChallengeResults.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengeResults.vue?vue&type=style&index=0&id=726e6934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726e6934",
  null
  
)

export default component.exports